import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useUserState = () => React.useContext(Context)
export const useUser = () => useUserState()?.user

const QUERY = gql`
  query User($id: ID) {
    user(id: $id, filter: { includeDisabled: true, includeDeleted: true, ignoreSegments: true }) {
      id
      name
      email
      mobileDetails
      contract {
        id
        insertedAt
        deleted
        enabled
        updatedAt
        deletedById
        group {
          id
          name
        }
        groups {
          id
          name
        }
        profile {
          id
          name
          label
        }
        fieldValues {
          id
          value
          field {
            id
            name
            type
            configuration
          }
        }
      }
    }
  }
`

const UsersLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    skip: !id,
    client: accountsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UsersLoader
